export default {"src":"/_next/static/media/info-circle-red.411c9bd0.svg","height":34,"width":35};